import {ApiFetch} from "../../api/apiFetch";
import Vuex from 'vuex';
import Vue from 'vue';
import {extractPriceAndInterval, formatBusinessHours} from "../../utils/delivery";

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            apiService: new ApiFetch('https://widget-pvz.dostavka.yandex.net'),
            physical: {
                dx: window.laravel.delivery.table.height,
                dy: window.laravel.delivery.table.depth,
                dz: window.laravel.delivery.table.width,
                weight_gross: window.laravel.delivery.table.weight
            },
            waiting_period: {
                pickup_point: "7 дней",
                terminal: "3 дня",
            },
            deliveryType: [
                "pickup_point",       // Пункт выдачи заказа
                // "terminal"            // Постамат
            ],
            deliverySource: window.laravel.delivery.source,
            payment_methods: [
                "already_paid",       // Доступен для доставки предоплаченных заказов
                // "card_on_receipt" // Доступна оплата картой при получении
            ]
        }
    },
    getters: {
        mapParams: function (state) {
            return {
                containerId: 'delivery-widget',
                params: {
                    city: "Москва, улица Арбат",              // Город отображаемый на карте
                    // Размеры виджета
                    size: {
                        height: "550px",
                        width: "100 %"
                    },
                    // delivery_price: "от 100 р.",     // Сумма доставки
                    // delivery_term: "от 1 дня",    // Срок доставки
                    physical_dims_weight_gross: state.physical.weight_gross,  // Вес отправления
                    physical_dims_dx: state.physical.dx,
                    physical_dims_dy: state.physical.dy,
                    physical_dims_dz: state.physical.dz,
                    source_platform_station: state.deliverySource,  // Станция отгрузки
                    delivery_price: price => price,            // Стоимость доставки
                    delivery_term: "от 1 дня",    // Срок доставки
                    show_select_button: true,        // Отображение кнопки выбора пункта выдачи заказа (false - скрыть кнопку, true - показать кнопку)
                    filter: {
                        // Тип способа доставки
                        type: state.deliveryType,
                        // is_yandex_branded: false,   // Тип пункта выдачи заказа (false - Партнерские ПВЗ, true - ПВЗ Яндекса)
                        show_post_office: true,
                        // Способ оплаты
                        // payment_methods_filter: 'and',
                        payment_methods: state.payment_methods
                    },
                    waiting_period: state.waiting_period,
                    minify_on_zoom: 14,
                    grid_size: 124,
                }
            }
        },
        calculationCostParams: (state) => function (destination) {
            return {
                billing_info: {
                    payment_method: "already_paid"
                },
                source: {
                    platform_station: {
                        // "platform_id: "0e29b316-6d8a-42fa-ad17-60a8a768b7c1"
                        platform_id: state.deliverySource
                    }
                },
                destination: {
                    type: "platform_station",
                    platform_station: {
                        // "platform_id: "ee701832-ff14-46df-8118-b19a4089d625"
                        platform_id: destination
                    }
                },
                info: {
                    operator_request_id: "1"
                },
                items: [
                    {
                        article: "1",
                        billing_details: {
                            assessed_unit_price: 1,
                            unit_price: 1
                        },
                        count: 1,
                        name: "1",
                        place_barcode: "1"
                    }
                ],
                last_mile_policy: "self_pickup",
                places: [
                    {
                        barcode: "1",
                        // Сантиметры
                        physical_dims: state.physical
                    }
                ],
                recipient_info: {
                    email: "dummy@inbox.ru",
                    first_name: "Dummy",
                    phone: "+79999999999"
                },
            }
        },
        infoPickUpPoint: () => function (destination) {
            return {
                "pickup_point_ids": [destination],
                "is_yandex_branded": false,
                "is_post_office": false,
                "payment_method": "already_paid"
            };
        }
    },
    actions: {
        calculateCost({state, commit, getters}, destination) {
            return new Promise((resolve, reject) => {
                state.apiService.post(
                    '/api/b2b/platform/offers/create',
                    getters.calculationCostParams(destination)
                ).then(response => {
                    if (Object(response).hasOwnProperty('code')) {
                        resolve({price: -1, interval: 0})

                        return;
                    }

                    resolve(extractPriceAndInterval(response.offers[0].offer_details));
                }).catch(error => reject(error))
            });
        },
        getInfoPickUpPoint({state, commit, getters}, destination) {
            return new Promise((resolve, reject) => {
                state.apiService.post(
                    '/',
                    getters.infoPickUpPoint(destination)
                ).then(response => {
                    if (!Object(response).hasOwnProperty('points') || response.points.length === 0) {
                        reject();

                        return;
                    }

                    resolve({
                        workschedule: formatBusinessHours(response.points[0]?.schedule?.restrictions),
                        phone: response.points[0]?.contact?.phone
                    })
                }).catch(error => reject(error))
            });
        }
    },
}
